import React from 'react';

import { LoaderColor, StyledLoader } from '@asd-stan/ui-kit/components/loader/loader.styled';

interface LoaderProps {
	width?: number;
	height?: number;
	color?: LoaderColor;
}

export const Loader: React.FC<LoaderProps> = ({ width, height, color = 'default' }) => {
	return (
		<StyledLoader $width={width} $height={height} $color={color} className="loader">
			<div className="loader-spinner" />
		</StyledLoader>
	);
};
